var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"position":"absolute","left":"24px"}},[_vm._m(0),_c('el-button',{staticClass:"btn btn4",attrs:{"type":"primary"},on:{"click":_vm.next}},[_vm._v("确认")])],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"textFive"},[_c('p',[_vm._v("您已成功提交申请，我们将尽快对您的资料进行验证审核。")]),_c('p',[_vm._v(" 您稍后可以在“我的融资\"界面查看融资进度及结果。 ")])])
}]

export { render, staticRenderFns }